import { render } from "./CreateOrUpdateConfigurationModal.vue?vue&type=template&id=5b65ca4d"
import script from "./CreateOrUpdateConfigurationModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateConfigurationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__